import { defineComponent as _defineComponent } from 'vue'
import Modal from "../Modal.vue";
  import { computed, reactive, ref, watch, watchEffect } from "vue";
  import CheckboxInput from "../input/CheckboxInput.vue";
  import useVuelidate from "@vuelidate/core";
  import { required, email, helpers } from "@vuelidate/validators";
  import Cleave from "vue-cleave-component";
  import { phoneNumberOption } from "@/helpers/cleavePlugin";
  import { validPhoneNumber } from "@/helpers/validation";
  import { resetVuelidateErrors } from "@/helpers/vuelidate";
  import store from "@/store";
  import LeadSourceEnum from "@/enums/LeadSourceEnum";
  import { POSITION, useToast } from "vue-toastification";
  import DropDown from "@/components/ui/dropdown/DropDown.vue";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'BuilderRequestMessageSendModal',
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    lot: {
      type: Object,
      required: true,
    },
  },
  emits: ["close", "send"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const toast = useToast();

  const emits = __emit;

  const props = __props;

  const rules = {
    firstName: { required },
    lastName: { required },
    email: { required, email },
    phone: {
      required,
      validPhoneNumber: helpers.withMessage(
        "Value must be valid phone number",
        validPhoneNumber
      ),
    },
    message: { optional: true },
  };

  const formFields = {
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: "",
    isRequestMessageBorrowCalculator: true,
  };
  const form = reactive(Object.assign({}, formFields));
  const v$ = useVuelidate(rules, form);
  const isLoading = ref(false);

  const onClose = () => {
    Object.assign(form, formFields);
    resetVuelidateErrors(v$);
    emits("close");
  };

  async function submit() {
    const isValid = await validateForm();

    if (!isValid) {
      return;
    }

    try {
      const { email, ...rest } = form;
      const data = {
        email: email.toLowerCase(),
        ...rest,
      };

      if (props.lot) {
        data.lotTitle = props.lot.lotId.title;
      }

      store.dispatch("estate/sendContactEmail", {
        estateId: props.lot?.lotId?.estateId.toString(),
        data,
      });
      emits("send");
      onClose();
    } catch (error) {
      console.log(error);
      toast.error("Error on sending contact form", {
        position: POSITION.TOP_LEFT,
      });
    } finally {
      isLoading.value = false;
    }
  }

  const validateForm = async () => {
    const isValid = await v$.value.$validate();

    v$.value.$touch();
    return isValid;
  };

const __returned__ = { toast, emits, props, rules, formFields, form, v$, isLoading, onClose, submit, validateForm, Modal, computed, reactive, ref, watch, watchEffect, CheckboxInput, get useVuelidate() { return useVuelidate }, get required() { return required }, get email() { return email }, get helpers() { return helpers }, get Cleave() { return Cleave }, get phoneNumberOption() { return phoneNumberOption }, get validPhoneNumber() { return validPhoneNumber }, get resetVuelidateErrors() { return resetVuelidateErrors }, get store() { return store }, get LeadSourceEnum() { return LeadSourceEnum }, get POSITION() { return POSITION }, get useToast() { return useToast }, DropDown }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})